import { render, staticRenderFns } from "./PayrollPage.vue?vue&type=template&id=1f3a4100"
import script from "./PayrollPage.vue?vue&type=script&lang=js"
export * from "./PayrollPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports